export default __webpack_public_path__ + "static/media/Star.040e72a4.svg";